import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_331 } from '../../../validators/331/ctrl331';
import { FormMapaATControlNames } from '../formMapaATControlNames';
import { TypeAttributionMarcheLot } from '../models/TypeAttributionMarcheLot';

@Component({
  selector: 'app-type-attribution-marche-lot',
  templateUrl: './type-attribution-marche-lot.component.html'
})
export class TypeAttributionMarcheLotComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() attribue: TypeAttributionMarcheLot;
  @Input() errorMessagePersonneMoral: string;
  @Input() type: string;
  @Input() index = 0;

  public step4 = new Step4();
  public radioButtonCtrlName: string
  public checkboxCtrlName: string;

  public rg1 = CTRL_331.id + '_1_';

  constructor() { }

  public ngOnInit() {
    this.radioButtonCtrlName = this.getUid() + '_SepAtt_sousTraitanceNon';
    this.checkboxCtrlName = this.getUid() + '_SepAtt_montantIndefini';
  }

  getUid() {
    return this.uid + '_SepSep_TypeAttributionMarcheLot';
  }

  public getUidTypeMontant() {
    return this.getUid() + '_SepSep_TypeMontant';
  }

  public isMontantDefini(): boolean {
    if (!this.parentForm.controls[this.checkboxCtrlName]?.value) {
      if (this.index > 0) {
        this.parentForm.addControl(this.getStepId() + this.rg1 + this.index, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_331_2Names_json(this.index) }));
      } else {
        this.parentForm.addControl(this.getStepId() + this.rg1 + this.index, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_331_1Names_json() }));
      }
    }
    return !this.parentForm.controls[this.checkboxCtrlName]?.value;
  }

  public isSousTraitance(): boolean {
    return this.parentForm.controls[this.radioButtonCtrlName].value;
  }

  public isLotAttribue() {
    return this.type !== RadioCheckBoxEnum.infructueux && this.type !== RadioCheckBoxEnum.sansSuite;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
}
